export default class UnsupportedSavegameError extends Error {
    constructor(message) {
        super(message);
        this.name = "UnsupportedSavegameError";
    }
}
